"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _urlParse = _interopRequireDefault(require("url-parse"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var zfetch = function zfetch(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parsedUrl = new _urlParse["default"](url, true);
  var headers = {};
  var queryParams = null;
  var postData = null;
  var queryMethod = null;
  var zpwa_params = {
    'zpwa': true
  };

  if (!options.method || options.method.toUpperCase() === 'GET') {
    if (options.body) {
      queryParams = options.body;
    }

    queryMethod = {
      method: 'GET'
    };
  } else {
    if (options.body) {
      postData = {
        body: options.body
      };
    }

    queryMethod = {
      method: options.method
    };
  }

  queryParams = Object.assign({}, parsedUrl.query, queryParams);

  if (!!options.headers) {
    headers = Object.assign({}, options.headers, headers);
  }

  if (!options.no_zpwa) {
    queryParams = Object.assign({}, queryParams, zpwa_params);
  }

  var additional = Object.assign({}, {
    credentials: 'same-origin'
  }, queryMethod, {
    headers: headers
  }, options.extras, postData); //Forming the new URL

  parsedUrl.set('query', queryParams);
  return fetch(parsedUrl.toString(), additional).then(checkStatus);
};

var _default = zfetch;
exports["default"] = _default;